import {
  AgencyTaskSchema,
  PostAttachmentSchema,
  PostPlatformSchema,
  PostSchema,
} from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { postsKeys } from './keys';

export type PostResponse = {
  post: PostSchema;
  postPlatforms: PostPlatformSchema[];
  postTasks: AgencyTaskSchema[];
  postAttachments: PostAttachmentSchema[];
};

export function usePost(postId: string) {
  return useQuery({
    queryKey: postsKeys.item(postId),
    queryFn: () => {
      return apiClient.get<ApiResponse<PostResponse>>(`/v1/posts/${postId}`, undefined, undefined);
    },
    enabled: !!postId,
  });
}
